const constants = {
  actions: {
    STORE_CADASTRE_LOOKUP: 'STORE_CADASTRE_LOOKUP_ACTION',
    STORE_CADASTRE_LOOKUP_ERROR: 'STORE_CADASTRE_LOOKUP_ERROR_ACTION',
    CADASTRE_LOOKUP_LOADING: 'CADASTRE_LOOKUP_LOADING_ACTION'
  },
  events: {
    CADASTRE_LOOKUP_LOADED: 'CADASTRE_LOOKUP_LOADED_EVENT',
    CADASTRE_LOOKUP_LOADING: 'CADASTRE_LOOKUP_LOADING_EVENT'
  },
  constants: {
    URL_SEFRAK_MAP: 'http://www.miljostatus.no/kart/?lang=no&layers=51:100;&basemap=KART'
  }
};

export = constants;
